import UserIndex from 'src/pages/Users/Index.vue'
import UserCreate from 'src/pages/Users/Create.vue'
import UserEdit from 'src/pages/Users/Edit.vue'
import UserRestore from 'src/pages/Users/Restore.vue'

const auth = { requiresAuth: true }
const admin = { requiresAdmin: true }

export default [
  {
    path: '/users',
    name: 'Benutzer',
    component: UserIndex,
    meta: { ...auth, ...admin }
  },
  {
    path: '/users/create',
    name: 'Benutzer Hinzufügen',
    component: UserCreate,
    meta: { ...auth, ...admin }
  },
  {
    path: '/users/:id/edit',
    name: 'Benutzer Bearbeiten',
    component: UserEdit,
    meta: { ...auth, ...admin }
  },
  {
    path: '/users/restore',
    name: 'Benutzer Zurüchksetzen',
    component: UserRestore,
    meta: { ...auth, ...admin }
  }
]
